
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whitepapers/[slug]",
      function () {
        return require("private-next-pages/whitepapers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whitepapers/[slug]"])
      });
    }
  